import { hasYesOrNo } from 'models/validate';
import legalAssociationsActivitiesOverthrowItemValidator from 'forms/sections/legal/associations/activitiesOverthrow/validators/item';
import { ValidateJSModel } from 'forms/shared/types';
import { LegalAssociationsActivitiesOverthrowModel } from './types';

const legalAssociationsActivitiesOverthrowValidator: ValidateJSModel<LegalAssociationsActivitiesOverthrowModel> = {
  HasActivities: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasActivities?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsActivitiesOverthrowItemValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsActivitiesOverthrowValidator;
